import clsx from 'clsx'
import React from 'react'

import styles from './StatMetrics.module.css'

export const StatMetricsSection: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => <div className={clsx(styles.missionStatsContainer, className)}>{children}</div>

export const StatMetricsGrid: React.FC<
  React.PropsWithChildren<{ columns?: string; className?: string }>
> = ({ children, columns = '1fr 1fr 1fr', className }) => (
  <div className={clsx(styles.missionStatsGrid, className)} style={{ gridTemplateColumns: columns }}>
    {children}
  </div>
)

export const StatMetricTile: React.FC<
  React.PropsWithChildren<{ label: React.ReactNode; className?: string }>
> = ({ label, children, className }) => (
  <div className={clsx(styles.statCard, className)}>
    <div className={styles.statLabel}>{label}</div>
    <div className={styles.statValue}>{children}</div>
  </div>
)
